import Vue from 'vue';
import Vuex from 'vuex';

import auth from './core/auth';
import authen from './core/authen';
//import menu from './core/menumanagement';
import menu from './core/menu.store';
import pmcreate from './promotion/create';
import pmmanage from './promotion/manage';
import pmtrack from './promotion/track';
import cpcreate from './campaign/create';
import reward from './campaign/reward';
import track from './campaign/track';
import setconfig from './setting/setconfig';
import bookprice from './pricing/bookprice';
import maintenance from './firebase/maintenance';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        authen,
        menu,
        pmmanage,
        pmcreate,
        pmtrack,
        cpcreate,
        reward,
        track,
        setconfig,
        bookprice,
        maintenance
    }
});